import { webAuth } from "$/lib/auth"

/**
 * For endpoints that carry no `@Auth` decorator on the API — currently the
 * translation dictionary, which the root layout loads on /login too.
 */
export const { publicRequest } = webAuth
